import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {convertToPersianDate} from '../../../../utilities/helper/GetPersianDateTime';

interface UserCardProps {
  cardWrapperClassName?: string;
  name: string;
  timeDate?: string;
  description: string;
  rate: number;
}
const UserCard = ({
  cardWrapperClassName,
  name,
  timeDate,
  description,
  rate,
}: UserCardProps) => {
  const maxStars = 5;
  const roundedRate = Math.round(rate);
  return (
    <div className="flex w-full">
      <div
        className={classNames(
          'p-2 gap-2 bg-white items-center h-[128px] flex flex-col rounded-[8px] border-[1px] border-gray-700 shadow-sm',
          cardWrapperClassName,
        )}
      >
        <div className="flex justify-between w-full text-sm">
          <span className="text-gray-700 font-Medium ">{name}</span>
          <div className="flex items-center gap-1">
            {Array.from(Array(maxStars).keys())
              .reverse()
              .map((item, index) => (
                <SpanIcon
                  key={index}
                  className={classNames({
                    'icon-namestar': item >= roundedRate,
                    'icon-nameStar text-[#F79009]': item < roundedRate,
                  })}
                />
              ))}
          </div>
        </div>
        <p className="h-[74px] text-sm w-full flex text-gray-950 overflow-hidden text-ellipsis">
          {description}
        </p>
        {timeDate && (
          <span className="w-full text-xs text-gray-500">
            {convertToPersianDate(timeDate)}
          </span>
        )}
      </div>
    </div>
  );
};

export default UserCard;
UserCard.defaultProps = {
  cardWrapperClassName: 'w-full',
};
